export default "__VITE_ASSET__bJ9T0X7A__"